import React from 'react';
import { Outlet } from 'react-router-dom';
import { Routes } from 'react-router-dom';

import ProtectedRoute from '../../components/helpers/ProtectedRoute';

import ManageAsset from './ManageAsset';
import AllDashboard from './AllDashboard';
import AllList from './AllList';

export default () => {
	return <Outlet />;
};

/*export default () => (
	<Routes>
		<ProtectedRoute exact path={`/`} component={AllList} />

		<ProtectedRoute exact path={`/assets`} component={AllDashboard} />

		<ProtectedRoute exact path={`/assets/all`} component={AllList} />
		<ProtectedRoute exact path={`/assets/new`} component={AllList} />
		<ProtectedRoute exact path={`/assets/all/issues`} component={AllList} />
		<ProtectedRoute exact path={`/assets/table/:tableId`} component={AllList} />
		<ProtectedRoute exact path={`/assets/issues`} component={AllList} />

		<ProtectedRoute
			exact
			path={`/assets/manufacturer/:manufacturerId`}
			component={AllDashboard}
		/>
		<ProtectedRoute
			exact
			path={`/assets/model/:modelId`}
			component={AllDashboard}
		/>
		<ProtectedRoute
			exact
			path={`/assets/category/:categoryId`}
			component={AllDashboard}
		/>
		<ProtectedRoute exact path={`/assets/tags/:tagIds`} component={AllList} />
		<ProtectedRoute
			exact
			path={`/assets/location/:locationId`}
			component={AllList}
		/>
		<ProtectedRoute exact path={`/assets/add`} component={ManageAsset} />
		<ProtectedRoute exact path={`/assets/:id/edit`} component={ManageAsset} />
	</Routes>
);
*/
